export default __webpack_public_path__ + "static/media/omoda-bold.cbdc43b1.ttf";